import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba5b5d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid p-1" }
const _hoisted_2 = { class: "col-12 flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-lg mb-0" }, "DiaGen", -1))
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12 md:col-8" }
const _hoisted_6 = { class: "overflow-x-auto" }
const _hoisted_7 = { class: "flex overflow-x-scroll" }
const _hoisted_8 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DiagramMenu = _resolveComponent("DiagramMenu")!
  const _component_DiagramStationManager = _resolveComponent("DiagramStationManager")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_DiagramTrainTypeManager = _resolveComponent("DiagramTrainTypeManager")!
  const _component_DiagramTimeTableManager = _resolveComponent("DiagramTimeTableManager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_DiagramMenu)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Panel, {
        header: "駅設定",
        toggleable: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DiagramStationManager)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Panel, {
        header: "ダイヤグラム",
        class: "my-2"
      }, {
        icons: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-search-minus",
            class: "p-button-sm p-button-secondary p-button-outlined mx-1",
            onClick: _ctx.zoomOut,
            disabled: !_ctx.canZoomOut
          }, null, 8, ["onClick", "disabled"]),
          _createVNode(_component_Button, {
            icon: "pi pi-search-plus",
            class: "p-button-sm p-button-secondary p-button-outlined mx-1",
            onClick: _ctx.zoomIn,
            disabled: !_ctx.canZoomIn
          }, null, 8, ["onClick", "disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              style: _normalizeStyle({ width: `${_ctx.width}px`, height: '350px' })
            }, [
              _createVNode(_component_Chart, {
                type: "line",
                data: _ctx.data,
                options: _ctx.graphOptions,
                ref: "chartRef",
                height: 300
              }, null, 8, ["data", "options"])
            ], 4)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Panel, {
        header: "種別と所要時間",
        class: "my-1 time-table-manager-panel"
      }, {
        icons: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-sm",
            icon: "pi pi-plus",
            onClick: _ctx.addInitialTrainType,
            disabled: !_ctx.canAddTrainType,
            label: "種別追加"
          }, null, 8, ["onClick", "disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainTypes.keys(), (trainTypeId) => {
              return (_openBlock(), _createBlock(_component_DiagramTrainTypeManager, {
                key: trainTypeId,
                trainTypeId: trainTypeId,
                class: "col"
              }, null, 8, ["trainTypeId"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_DiagramTimeTableManager, {
        diagramDataSetId: _ctx.showingTrainId,
        refreshChart: _ctx.chartRef?.refresh
      }, null, 8, ["diagramDataSetId", "refreshChart"])
    ])
  ]))
}